<template>

<div v-if="data" class="contentWrapper" v-bind:style="{ width: settings.width+'%' }">

    <div class="prop-wrap">

        <div :class="[{'bordered':  settings.isBordered }, 'prop-inner']">

            <!-- TITLE -->
            <h1 class="title">{{ contentElementData[0].value }}</h1>

            <!-- TEXT -->
            <div class="puzzleText">{{ contentElementData[1].value }}</div>

            <!-- IMAGE -->
            <div class="puzzleImages is-clearfix">

                <template v-for="el in contentElementData[2].assets">
                    <img class="lazy-img-fadein is-pulled-left" v-lazy="getAsset(el.asset)" />
                </template>

                <div class="puzzleSolution is-pulled-right">{{ contentElementData[3].value }}</div>

                <template v-for="el in contentElementData[4].assets">
                    <img class="lazy-img-fadein is-pulled-left" v-lazy="getAsset(el.asset)" />
                </template>

                <template v-for="el in contentElementData[5].assets">
                    <img class="lazy-img-fadein is-pulled-left" v-lazy="getAsset(el.asset)" />
                </template>

                <template v-for="el in contentElementData[6].assets">
                    <img class="lazy-img-fadein is-pulled-left" v-lazy="getAsset(el.asset)" />
                </template>
            </div>
        </div>

    </div>

</div>

</template>



<script>

export default {

    props: ['data', 'settings'],

    data(){
		return {
            contentElementData: []
		}
	},

    created() {
        this.contentElementData = this.data.contentElement.contentElementData;
    },

    mounted() {
        // console.log(this.data);
    },

    methods: {

        getAsset(asset) {

            // return this.$config.assets + asset.path + '/' + asset.filename;
            var url = asset.filename;

            // get file extension
            var ext = url.split('.').pop();

            // check if we've an image
            if(ext == 'jpg' || ext == 'gif' || ext == 'png') {
                return this.$config.assets + asset.path + '/' + asset.filename;
            }

            // console.log(this.$config.assets + asset.path + '/' + asset.filename.substr(0, asset.filename.lastIndexOf(".")) + ".jpg");

            // otherwise we've to display a standard image
            var extensions = ['ai', 'eps', 'indd', 'pdf', 'psd', 'tiff'];

            if(extensions.indexOf(ext) > -1) {
                return require('../../../assets/img/fileTypes/datei-'+ext+'.png');
            }

        }
    }

}

</script>



<style scoped>

.puzzleText {
    margin: 0 0 5% 0;
}
.puzzleImages {

}
.puzzleImages img {
    max-width: 10%;
    height: auto;
}
.puzzleSolution {
    font-size: 75%;
}
</style>
